import { render } from "./TabsComponent.vue?vue&type=template&id=f99ca6d2&scoped=true"
import script from "./TabsComponent.vue?vue&type=script&lang=js"
export * from "./TabsComponent.vue?vue&type=script&lang=js"

import "./TabsComponent.vue?vue&type=style&index=0&id=f99ca6d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f99ca6d2"]])

export default __exports__